var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSuccess = function SvgTextSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.757 14.527.002-11.375-4.375-.001V.526l11.375.001v2.625h-4.375l-.002 11.375h-2.625Zm-7.875-.002.001-7H.258V4.9l7.875.001v2.625H5.508v7H2.881Z",
    fill: "#43A2AC"
  })));
};
export default SvgTextSuccess;